export const generateKey = (index, generatedWord) => `${index}_${generatedWord}`;
